import { render, staticRenderFns } from "./StoryblokHeroBanner.vue?vue&type=template&id=be0b9ae8&"
import script from "./StoryblokHeroBanner.vue?vue&type=script&lang=ts&"
export * from "./StoryblokHeroBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports